<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="booktitle"><em>FIRST BLUE</em></h1>
<p class="indenttitle">                   <img alt="Image" src="OEBPS/images/copy.jpg"/> THE STORY OF</p>
<p class="indenttitle">              WORLD WAR II ACE</p>
<p class="indenttitle">          BUTCH VORIS</p>
<p class="indenttitle">     AND THE CREATION OF</p>
<p class="indenttitle">THE BLUE ANGELS</p>
<h1 class="author"><em>ROBERT K. WILCOX</em></h1>
<p class="indenttitlea">Foreword by James Lovell</p>
<p class="publisher"><span class="smallcaps">THOMAS DUNNE BOOKS / ST. MARTIN’S PRESS</span> <img alt="Image" src="OEBPS/images/pub.jpg"/> <span class="smallcaps">NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_tp_r1.vue?691c980c